export default "__VITE_ASSET__9ef6443e__"